export default __webpack_public_path__ + "static/media/bt.7b92eb4c.svg";